import { render, staticRenderFns } from "./microAccount.vue?vue&type=template&id=e12275ba&scoped=true&"
import script from "./microAccount.vue?vue&type=script&lang=js&"
export * from "./microAccount.vue?vue&type=script&lang=js&"
import style0 from "./microAccount.vue?vue&type=style&index=0&id=e12275ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12275ba",
  null
  
)

export default component.exports